import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3345857214/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
